import { useTu } from "@src/appV2/i18n/useTu";
import { Box } from "@mui/material";
import { type UseModalState } from "@src/lib/ui-react";
import { Dialog } from "../../components/Dialog";
import { DialogFooter } from "../../components/DialogFooter";
import { Text } from "../../components/Text";

interface ChatDeleteMessageDialogProps {
  modalState: UseModalState;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirmation dialog for deleting a chat message. Destructive — once
 * confirmed, the message is permanently removed for everyone in the channel.
 */
export function ChatDeleteMessageDialog(props: ChatDeleteMessageDialogProps) {
  const { tu } = useTu("chat");

  const { modalState, isDeleting, onConfirm, onCancel } = props;

  return (
    <Dialog
      modalState={modalState}
      title={tu("Delete message?")}
      footerContent={
        <DialogFooter
          primaryAction={{
            label: "Delete",
            variant: "danger",
            isLoading: isDeleting,
            disabled: isDeleting,
            onClick: onConfirm,
          }}
          secondaryAction={{
            label: "Cancel",
            disabled: isDeleting,
            onClick: onCancel,
          }}
        />
      }
      onClose={onCancel}
    >
      <Box>
        <Text variant="body1">{tu("This message will be permanently removed for everyone.")}</Text>
      </Box>
    </Dialog>
  );
}
